import {Pipe, PipeTransform} from "@angular/core";
import {MasterDataService} from "../../Services/MasterDataService";
import * as moment from 'moment';

@Pipe({ name: 'PropertyDateTimeFormatPipe' })
export class PropertyDateTimeFormatPipe implements PipeTransform {
    constructor(private masterService: MasterDataService) {
    }
    transform(value: Date, propertyId: number): string {
        if (!value) {
            return '';
        }
        propertyId = +propertyId;
        propertyId = isNaN(propertyId) ? null : propertyId;
        const propertyDateFormat = propertyId && this.masterService.GetPropertyDateFormat(propertyId);
        return propertyDateFormat
            ? moment(value).format(propertyDateFormat)
            : value.toLocaleString()
    }
}
